import { el } from "@dhx/ts-common/dom";
import { getCount } from "./helpers";

export function navItem(item: any, widgetName: string, collapsed?: boolean) {
	const getAriaAttrs = item => {
		const attrs = {
			"aria-disabled": item.disabled ? "true" : "false",
			"aria-label": item.value || " ",
		};
		const isItemActivated = item.active || item.$activeParent;

		if (item.type === "selectButton" || item.items) {
			attrs["id"] = item.id;
			attrs["aria-haspopup"] = "menu"; // menu has hot keys, listbox doesn't have

			if (isItemActivated) {
				attrs["aria-expanded"] = "true";
			}
		} else {
			if (item.twoState || isItemActivated) {
				attrs["aria-pressed"] = isItemActivated ? "true" : "false";
			}

			if (!item.value && item.icon && item.tooltip) {
				attrs["aria-label"] = `${item.tooltip} ${item.count || ""}`;
			}
		}

		return attrs;
	};
	const baseClass = " dhx_" + widgetName + "-button";
	return el(
		"button",
		{
			class:
				"dhx_button" +
				baseClass +
				(item.active || item.$activeParent ? baseClass + "--active" : "") +
				(item.disabled ? baseClass + "--disabled" : "") +
				(item.$openIcon ? baseClass + "--select" : "") +
				(item.circle ? baseClass + "--circle" : "") +
				(item.size ? " " + baseClass + "--" + item.size : "") +
				(!item.value && item.icon ? baseClass + "--icon" : "") +
				(item.css ? " " + item.css : ""),
			"data-dhx-id": item.id,
			disabled: item.disabled,
			type: "button",
			...getAriaAttrs(item),
		},
		[
			item.icon &&
				el("span", {
					class: item.icon + baseClass + "__icon",
					"aria-hidden": "true",
				}),
			item.html &&
				el("div", {
					class: baseClass.trim() + "__html",
					".innerHTML": item.html,
				}),
			!item.html &&
				item.value &&
				el(
					"span",
					{
						class: baseClass.trim() + "__text",
					},
					item.value
				),
			item.count > 0 && getCount(item, baseClass + "__count", collapsed),
			item.$openIcon &&
				el("span.dxi.dxi-menu-right", {
					class: baseClass + "__caret",
					"aria-hidden": "true",
				}),
		]
	);
}
